/**
 * Барааны зураг — аппын бүх хүснэгт, жагсаалт, дэлгэрэнгүйд нэг ижил.
 *
 * Зураггүй эсвэл холбоос нь эвдэрсэн (ачаалагдаагүй) үед эвдэрсэн дүрс / хоосон
 * зурвасын оронд `CiImageOff` icon-той ижил хэмжээтэй нүд харуулна. `style`
 * (булан, хүрээ, сүүдэр) нь зураг, icon хоёуланд нь үйлчилнэ.
 */

import { useEffect, useState } from 'react';
import { Image } from 'antd';
import { CiImageOff } from 'react-icons/ci';

const PLACEHOLDER_BG = '#f9fafb';
const PLACEHOLDER_COLOR = '#98a2b3';

/** Icon-ий хэмжээ — нүдний ~55%, хувиар өгсөн (100%) үед тогтмол */
const getIconSize = (size) => (typeof size === 'number' ? Math.round(size * 0.55) : 32);

const ProductImage = ({
  src,
  alt = 'Барааны зураг',
  size = 40,
  preview = false,
  style,
  wrapperStyle,
  iconSize,
}) => {
  const [failed, setFailed] = useState(false);

  // src солигдвол (мөр дахин ашиглагдах г.м.) дахин оролдоно
  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    // objectFit зөвхөн <img>-д хамаатай
    const { objectFit, ...boxStyle } = style ?? {};

    return (
      <span
        role="img"
        aria-label={alt}
        style={{
          borderRadius: 4,
          backgroundColor: PLACEHOLDER_BG,
          ...boxStyle,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
          width: size,
          height: size,
          flexShrink: 0,
          color: PLACEHOLDER_COLOR,
        }}
      >
        <CiImageOff size={iconSize ?? getIconSize(size)} />
      </span>
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={size}
      height={size}
      preview={preview}
      onError={() => setFailed(true)}
      style={style}
      wrapperStyle={wrapperStyle}
    />
  );
};

export default ProductImage;
